export const RANKING_SIZE = 5
export const LISTING_IDS_LIMIT = 50
